import React from 'react';
import {View, TouchableOpacity,FlatList,StyleSheet} from 'react-native';
import {AssignedProjectCard} from './ProjectCard';
import colors from 'theme/Colors';
import {spacing, corner_radius} from 'theme/Units';
import Circle from 'components/common/animation/Circle';
import {projectList} from 'redux/selectors/projectSelector';
import {useSelector} from 'react-redux';
import {Text} from 'ui-kits';

type propType = Readonly<{
  goToViewAndManageProjects: () => void;
  goToProjectDashboard: (id: string, name: string) => void;
}>;
export function OngoingProjects(props: propType) {
  const {goToProjectDashboard, goToViewAndManageProjects} = props;
  const seperator = () => <View style={styles.seperator} />;
  const projects = useSelector(projectList);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.heading}>Ongoing Projects</Text>
        <TouchableOpacity
          onPress={goToViewAndManageProjects}
          style={styles.button}>
          <Text style={styles.buttonText}>View More</Text>
        </TouchableOpacity>
      </View>
      {projects.length > 0 ? (
        <FlatList
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          data={projects}
          keyExtractor={item => item?.id?.toString()}
          renderItem={({item}) => (
            <AssignedProjectCard
              {...item}
              id={`PROJ-${item.id.toString().padStart(3, '0')}`}
              key={item.id}
              goToProjectDashboard={goToProjectDashboard}
            />
          )}
          ItemSeparatorComponent={seperator}
        />
      ) : (
        <Text style={styles.message}>
          No assigned projects yet! Stay tuned for upcoming opportunities.
        </Text>
      )}

      <Circle
        blurAmount={60}
        color={colors.palette.brandBlue}
        opacity={0.5}
        size={220}
        zIndex={-100}
        x={93}
        y={30}
        width={220}
        height={180}
      />
      <Circle
        blurAmount={70}
        color={colors.palette.brandPink}
        opacity={0.2}
        size={350}
        zIndex={-500}
        x={70}
        y={40}
      />
      <Circle
        blurAmount={80}
        color={colors.palette.brandPink}
        opacity={0.6}
        size={60}
        zIndex={-500}
        x={40}
        y={6}
      />
      <Circle
        blurAmount={70}
        width={130}
        height={70}
        color={colors.palette.brandPink}
        opacity={0.8}
        zIndex={-500}
        x={30}
        y={50}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  seperator: {width: spacing['2']},
  message: {
    fontSize: 18,
    fontWeight: 500,
  },
  container: {
    backgroundColor: colors.palette.white,
    padding: spacing['4'],
    gap: spacing['4'],
    borderWidth: 1,
    borderColor: colors.palette.neutralN300,
    borderRadius: corner_radius['rounded-md'],
    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowOffset: {width: 5, height: 5},
    shadowOpacity: 0.5,
    shadowRadius: 10,
  },
  heading: {
    fontSize: 24,
    fontWeight: 600,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    backgroundColor: 'rgba(255,255,255,0.5)',
    justifyContent: 'center',
    height: 'fit-content',
    paddingVertical: spacing['1'],
    paddingHorizontal: spacing['4'],
    borderRadius: corner_radius.rounded,
  },
  buttonText: {
    color: colors.palette.blueInfo,
    fontSize: 16,
    fontWeight: 600,
  },
});
